// extracted by mini-css-extract-plugin
export default {"container":"ScreenshotSelector_container__EAeQ0"};